/* eslint-disable import/prefer-default-export */
import { MARKETPLACE_STATUS_UPDATE } from '../constants/marketplaceConstants';

export const updateMarketPlaceStatus = invite => ({
  type   : MARKETPLACE_STATUS_UPDATE,
  invite,
});
